module.exports = __webpack_public_path__ + "static/media/test11_4.b58df704.png";